import React from "react";

import DateInput from "../../../ui/components/DateInput/DateInput";

import useFormField from "../../hooks/useFormField";

export default function FormDateInput(props) {
	const { field } = useFormField(props);

	return <DateInput {...field} value={field.value} ref={undefined} />;
}
